function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45 22.5C45 34.9292 34.9255 45 22.5 45C10.0745 45 0 34.9292 0 22.5C0 10.0781 10.0745 0 22.5 0C34.9255 0 45 10.0781 45 22.5ZM22.5 27.0363C20.1951 27.0363 18.3266 28.9048 18.3266 31.2097C18.3266 33.5146 20.1951 35.3831 22.5 35.3831C24.8049 35.3831 26.6734 33.5146 26.6734 31.2097C26.6734 28.9048 24.8049 27.0363 22.5 27.0363ZM18.5377 12.0351L19.2107 24.3739C19.2422 24.9512 19.7196 25.4032 20.2978 25.4032H24.7022C25.2804 25.4032 25.7578 24.9512 25.7893 24.3739L26.4623 12.0351C26.4963 11.4115 25.9998 10.8871 25.3752 10.8871H19.6247C19.0002 10.8871 18.5037 11.4115 18.5377 12.0351Z",
  fill: "#EB5757"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.498afe59.svg";
export { ForwardRef as ReactComponent };